import formatDate from '@/services/general/formatDate';
import { SIZE_LIBELLE_REGROUPEMENT_PERSO } from '@/configuration/dcf/dcfConf';

export default function getLibelleRegroupementPerso(lignes, referencePerso, i18n) {
  let libelle = '';
  const lignesWithReferencePerso = lignes.filter((ligne) => {
    return ligne.referencePersonnalise === referencePerso;
  });
  lignesWithReferencePerso.forEach((ligne) => {
    const objectForCreateLibelle = {
      libelle: ligne.libelle,
      anneeSemaine: ligne.ligneReseau?.anneeSemaine ?? null,
      dateDebut: ligne.dateDebut,
      dateFin: ligne.dateFin,
    };
    if (libelle) libelle += '\n';
    libelle += objectForCreateLibelle.libelle;
    if (objectForCreateLibelle.anneeSemaine) {
      libelle += ' - ' + i18n.t('detail.article.week',
        { week: objectForCreateLibelle.anneeSemaine.toString().substr(4, 6) });
    }
    if (objectForCreateLibelle.dateDebut) {
      libelle += ' - ' + formatDate(objectForCreateLibelle.dateDebut);
    }
    if (objectForCreateLibelle.dateFin) {
      libelle += ' - ' + formatDate(objectForCreateLibelle.dateFin);
    }
  });
  return libelle.substring(0, SIZE_LIBELLE_REGROUPEMENT_PERSO);
}
